// extracted by mini-css-extract-plugin
module.exports = {"loader":"LoadingPage_loader__1dkcl","loaderText":"LoadingPage_loaderText__1lg5Y","loaderImage":"LoadingPage_loaderImage__1KhXx"};